module.exports = __webpack_public_path__ + "static/img/4370_phase_function_Paper_Points.65726ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4370_phase_function_Paper_Points.png
// module id = +14P
// module chunks = 0